class SwiperProductGallery {
  constructor(container) {
    this.container = container;
    this.mainEl = container.querySelector('.js-product-gallery-main');
    this.thumbsEl = container.querySelector('.js-product-gallery-thumbs');

    if (!this.mainEl) return;

    this.init();
    this.bindVariantChange();
  }

  init() {
    let thumbsSwiper = null;

    if (this.thumbsEl) {
      thumbsSwiper = new Swiper(this.thumbsEl, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });
    }

    this.mainSwiper = new Swiper(this.mainEl, {
      slidesPerView: 1,
      spaceBetween: 12,

      navigation: {
        nextEl: this.container.querySelector(
          '.swiper-product-gallery__arrow--next'
        ),
        prevEl: this.container.querySelector(
          '.swiper-product-gallery__arrow--prev'
        ),
      },

      thumbs: thumbsSwiper
        ? {
            swiper: thumbsSwiper,
          }
        : undefined,
    });
  }

  bindVariantChange() {
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      ({ data }) => {
        const variant = data?.variant;

        if (!variant?.featured_media?.id) return;

        // Prevent another product section from controlling this gallery
        if (
          data.sectionId &&
          String(data.sectionId) !==
            String(this.container.dataset.sectionId)
        ) {
          return;
        }

        this.slideToMedia(
          variant.featured_media.id,
          true
        );
      }
    );
  }

  slideToMedia(mediaId, scroll = true) {
    const slides = Array.from(
      this.container.querySelectorAll(
        '.swiper-product-gallery__slide'
      )
    );

    const index = slides.findIndex(
      (slide) =>
        String(slide.dataset.mediaId) === String(mediaId)
    );

    if (index === -1) return;

    this.mainSwiper.slideTo(index);

    if (scroll) {
      this.scrollToGallery();
    }
  }

  scrollToGallery() {
    const header = document.querySelector('.header-wrapper');
    const headerHeight = header?.offsetHeight || 0;

    const top =
      this.container.getBoundingClientRect().top +
      window.scrollY -
      headerHeight -
      20;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  }
}

function initSwiperProductGalleries(scope = document) {
  const galleries = scope.querySelectorAll('.swiper-product-gallery');

  galleries.forEach((gallery) => {
    if (gallery.dataset.galleryInitialized === 'true') return;
    gallery.dataset.galleryInitialized = 'true';
    new SwiperProductGallery(gallery);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSwiperProductGalleries();
});

document.addEventListener('shopify:section:load', (event) => {
  initSwiperProductGalleries(event.target);
});

